export default {
  title: {
    id: 'funnel_address_confirmation_user_information_title',
    defaultMessage: 'Personal information',
  },
}
